import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { HomeComponent } from './pages/home/home.component';
import { TeamComponent } from './pages/team/team.component';
import { ContactComponent } from './pages/contact/contact.component';
import { SpecialisatiesComponent } from './pages/specialisaties/specialisaties.component';
import { FooterComponent } from './components/footer/footer.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { HeroComponent } from './components/hero/hero.component';
import { BranchComponent } from './branch/branch.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { PraktischComponent } from './pages/praktisch/praktisch.component';
import { MemberCardComponent } from './components/member-card/member-card.component';
import { TeamfilterPipe } from './pipes/teamfilter.pipe';
import { FormsModule } from '@angular/forms';
import { TeamlidComponent } from './pages/teamlid/teamlid.component';
import { VestigingComponent } from './pages/vestiging/vestiging.component';
import { VisieComponent } from './pages/visie/visie.component';
import { VacaturesComponent } from './pages/vacatures/vacatures.component';
import { VacatureComponent } from './pages/vacature/vacature.component';
import { SafePipe } from './pipes/safe.pipe';
import { SpecialisatieCardComponent } from './components/specialisatie-card/specialisatie-card.component';
import { VestigingCardComponent } from './components/vestiging-card/vestiging-card.component';
import { MdtohtmlPipe } from './pipes/mdtohtml.pipe';
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import { CookiesComponent } from './pages/cookies/cookies.component';
import { UnderconstructionComponent } from './pages/underconstruction/underconstruction.component';
import { ContactSimpleComponent } from './pages/contact-simple/contact-simple.component';
import { DisciplineComponent } from './pages/discipline/discipline.component';
import { DisciplinesComponent } from './pages/disciplines/disciplines.component';
import { environment } from '../environments/environment';
import { DisciplineCardComponent } from './components/discipline-card/discipline-card.component';
import { SpecialisatieComponent } from './pages/specialisatie/specialisatie.component';
import { VormingenComponent } from './pages/vormingen/vormingen.component';
import { VormingComponent } from './pages/vorming/vorming.component';
import { SpecLogoPraktischComponent } from './pages/spec-logo-praktisch/spec-logo-praktisch.component';
import { InfoboxCardComponent } from './components/infobox-card/infobox-card.component';
import { InfoboxComponent } from './pages/infobox/infobox.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';

const cookieConfig:NgcCookieConsentConfig = {
  "cookie": {
    "domain": environment.cookieUrl
  },
  "position": "bottom-right",
  "theme": "edgeless",
  "palette": {
    "popup": {
      "background": "#eaeaea",
      "text": "#6c6c6c",
      "link": "#333"
    },
    "button": {
      "background": "#af865d",
      "text": "#ffffff",
      "border": "transparent"
    }
  },
  "type": "info",
  "content": {
    "message": "Deze website gebruikt cookies om je de best mogelijk ervaring te kunnen bieden.",
    "dismiss": "Accepteren",
    "allow": "Accepteren",
    "deny": "Weigeren",
    "link": "Meer info",
    "href": "/cookies",
    "policy": "Cookie Policy"
  }
}

@NgModule({
  declarations: [
    MdtohtmlPipe,
    AppComponent,
    TopbarComponent,
    HomeComponent,
    TeamComponent,
    ContactComponent,
    SpecialisatieComponent,
    SpecialisatiesComponent,
    FooterComponent,
    PageNotFoundComponent,
    HeroComponent,
    BranchComponent,
    PraktischComponent,
    MemberCardComponent,
    TeamfilterPipe,
    TeamlidComponent,
    VestigingComponent,
    VisieComponent,
    VacaturesComponent,
    VacatureComponent,
    SafePipe,
    SpecialisatieCardComponent,
    VestigingCardComponent,
    CookiesComponent,
    UnderconstructionComponent,
    ContactSimpleComponent,
    DisciplineComponent,
    DisciplinesComponent,
    DisciplineCardComponent,
    VormingenComponent,
    VormingComponent,
    SpecLogoPraktischComponent,
    InfoboxCardComponent,
    InfoboxComponent,
    PrivacyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgcCookieConsentModule.forRoot(cookieConfig)
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent, TopbarComponent]
})
export class AppModule { }
